export default [{"url":"https://hayzedd-test-0.api.invexerp.io","name":"Branch 1","port":"5025","isStore":true,"isHQ":true}]